import {CardProduct} from "@/components/CardProduct/interface";
import {Palier as PalierInterface} from "@/ts/interface/detailOffre";
import {Massifications} from "@/ts/interface/offres";

import {findDataArticle} from "./findDataArticle";
import {isPuriel} from "./isPuriel";

interface EngagementValeur {
  engagement_value: number;
  engagement_adherents: number;
  engagement_article: number;
}

export function isGlobalPalier(
  massification: Massifications,
  article: CardProduct,
): boolean {
  const {
    paliers,
  }: {
    paliers: PalierInterface[];
  } = massification;

  const foundPalier: PalierInterface[] = findDataArticle(
    paliers,
    article.article_id,
  );
  const palierArticle: number[][] | undefined = foundPalier?.map(palier => {
    return palier.articles;
  });
  const isGlobalPalier: boolean = palierArticle?.[0].length > 1;
  return isGlobalPalier;
}

// Retourne (engagement_article, engagement_adherents, engagement_value) en fonction du type de palier et du type d'offre
// Engagement_value contient la valeur à l'article pourles  palier à l'article et à l'offre pour les paliers à l'offre
// Engagement_article contient les engagements que de l'article
// Engagement_adhérent contient les adhérent engagés à l'article pour les  palier à l'article et à l'offre pour les paliers à l'offre
export function getEngagementValue(
  massification: Massifications,
  article: CardProduct,
): EngagementValeur {
  const isGlobal = isGlobalPalier(massification, article);
  const isPalierPrix: boolean = massification.type_palier === "prix";
  const {
    engagement_total_unites,
    engagement_total_montant,
    engagement_total_adherents,
  } = massification;
  const {
    engagement_total_unites: engagement_article_unites,
    engagement_total_montant: engagement_article_montant,
    engagement_total_adherents: engagement_article_adherents,
  } = article;

  const engagement_article = isPalierPrix
    ? parseFloat(engagement_article_montant)
    : engagement_article_unites;
  const engagement_massification = isPalierPrix
    ? parseFloat(engagement_total_montant)
    : engagement_total_unites;

  //récupére la valeur d'engagement a utiliser
  const engagement_value = isGlobal
    ? engagement_massification
    : engagement_article;
  const engagement_adherents = isGlobal
    ? engagement_total_adherents
    : engagement_article_adherents;
  return {engagement_article, engagement_adherents, engagement_value};
}

export function getResumeEngagement(
  massification: Massifications,
  article: CardProduct,
): string {
  const isPalierPrix: boolean = massification.type_palier === "prix";
  const isGlobal: boolean = isGlobalPalier(massification, article);
  const {engagement_article, engagement_adherents, engagement_value} =
    getEngagementValue(massification, article);

  const engagementNbuite =
    engagement_value && engagement_adherents
      ? `${engagement_adherents} adhérent${isPuriel(engagement_adherents)} engagé${isPuriel(engagement_adherents)} sur ${new Intl.NumberFormat("fr-FR").format(engagement_value)} ${isPalierPrix ? "€" : `unité${isPuriel(engagement_value)}`}  ${isGlobal ? `( ${engagement_article} sur produit )` : ""}`
      : "";

  return engagementNbuite;
}

export function hasPalier(
  nbPalier: number | undefined | null,
  firstPalier: number | undefined | null,
): boolean {
  if (nbPalier && firstPalier) {
    return nbPalier > 1 || firstPalier !== 1;
  }
  return false;
}
